import { SonarRecord } from '@ui/records';
import { PERISCOPE_ENTITY_COPY, PERISCOPE_ENTITY_RELATED_OBJECT_TYPES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
export const PeriscopeRelatedObject = ({ onRelatedObjectClick, relatedObject }) => {
    const { displayName, isActive, relationships, sonarObjectId } = relatedObject;
    const handleClick = useCallback(() => {
        if (onRelatedObjectClick) {
            onRelatedObjectClick(relatedObject);
        }
    }, [relatedObject, onRelatedObjectClick]);
    return (React.createElement(SonarRecord, { isActive: isActive, name: displayName, onClick: handleClick, sonarObjectId: sonarObjectId }, relationships === null || relationships === void 0 ? void 0 : relationships.map(({ name, type }) => {
        const [referencedBy, ...nameWithoutPrefix] = name.split('.');
        const key = `${name}-${type}`;
        const objectName = type === PERISCOPE_ENTITY_RELATED_OBJECT_TYPES.LOOKUP ? displayName : referencedBy;
        const content = PERISCOPE_ENTITY_COPY.IS_LOOKUP_OF_OBJECT(nameWithoutPrefix.join('.'), objectName);
        return React.createElement("div", { key: key }, content);
    })));
};
